import {
  Icon,
  ICONS,
  Button,
  PopoverTooltip,
  Typography,
  TYPOGRAPHY_SIZE,
  PLATFORM_THEME_COLORS,
} from '@thinknet-gmbh/platform-common-ui';
import {
  HeaderContainer,
  ElementContainer,
  PopoverInfoWrapper,
} from 'src/pages/gantt/gantt-calendar/gantt-view/components/gantt-popover/gantt-popover.styles';
import { formatByMask } from 'src/common/helpers/common.helpers';

import { IEmployeeGanttInfo } from './employee-gantt-info.interface';
import { EmployeeActionsWrapper } from './employee-gantt-info.styles';

const EmployeeGanttInfo = ({
  employee,
  t,
  onClose,
  openAbsenceModal,
  setEmployeesOrder,
  actionAllowed,
}: IEmployeeGanttInfo) => (
  <PopoverInfoWrapper>
    <HeaderContainer>
      <Typography weight="bold" size={TYPOGRAPHY_SIZE.medium}>
        {t('employee:labels.employeeDetails')}
      </Typography>
      <Icon
        size={22}
        onClick={onClose}
        rightMargin={false}
        icon={ICONS.xCloseIcon}
        color={PLATFORM_THEME_COLORS.grayVariations.murky}
      />
    </HeaderContainer>
    <ElementContainer>
      <Typography weight="bold">{t('common:labels.fullName')}:</Typography>
      <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{employee.name}</Typography>
    </ElementContainer>
    <ElementContainer>
      <Typography weight="bold">{t('common:labels.email')}:</Typography>
      <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>{employee.email}</Typography>
    </ElementContainer>
    <ElementContainer>
      <Typography weight="bold">{t('common:labels.phoneNumber')}:</Typography>
      <Typography fontColor={PLATFORM_THEME_COLORS.primary.grey}>
        {formatByMask(employee.phoneNumber, '+## ### ### #######')}
      </Typography>
    </ElementContainer>

    <EmployeeActionsWrapper color={PLATFORM_THEME_COLORS.primary.blue}>
      <Button
        icon={ICONS.plus}
        type="text"
        iconColor={PLATFORM_THEME_COLORS.primary.blue}
        onClick={openAbsenceModal}
        disabled={!actionAllowed}
      >
        {t('employee:labels.createAnAbsence')}
      </Button>
      <div>
        <PopoverTooltip title={t('gantt:labels.moveLeftEmployee')} placement="right">
          <div>
            <Icon
              size={18}
              onClick={() => actionAllowed && setEmployeesOrder(employee._id, -1)}
              rightMargin={false}
              icon={ICONS.chevronLeft}
              color={
                actionAllowed
                  ? PLATFORM_THEME_COLORS.primary.blue
                  : PLATFORM_THEME_COLORS.grayVariations.medium
              }
            />
          </div>
        </PopoverTooltip>

        <PopoverTooltip title={t('gantt:labels.moveRightEmployee')} placement="right">
          <div>
            <Icon
              size={18}
              onClick={() => actionAllowed && setEmployeesOrder(employee._id, 1)}
              rightMargin={false}
              icon={ICONS.chevronRight}
              color={
                actionAllowed
                  ? PLATFORM_THEME_COLORS.primary.blue
                  : PLATFORM_THEME_COLORS.grayVariations.medium
              }
            />
          </div>
        </PopoverTooltip>
      </div>
    </EmployeeActionsWrapper>
  </PopoverInfoWrapper>
);

export default EmployeeGanttInfo;
